var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-detail-more"},[_c('router-link',{staticClass:"news-detail-more__title",attrs:{"to":{ name: 'NewsDetail', params: { id: _vm.news.id } }}},[_vm._v(" "+_vm._s(_vm.news.headline)+" ")]),_c('div',{staticClass:"news-detail-more__text",domProps:{"innerHTML":_vm._s(_vm.news.simple_text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }